<template>
    <div class="cliente">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Cliente" sub="" />
        </div>

        <div id="pageGrid" v-show="!modalActive">
            <div id="barraBotoes">
                <b-row>
                    <b-col cols="10" class="text-left">
                        <b-button id="btn-principal" variant="success" 
                            @click="addCliente()" size="lgx" class="mb-2 mr-2" v-if="user.cli_adi">  
                            <i class="fa fa-plus"></i> Adicionar
                        </b-button>
                        <b-button id="btn-pesquisa" variant="secondary" 
                            @click="togglePesquisa()" size="lgx" class="mb-2 mr-2">  
                            <i class="fa fa-search"></i> Pesquisar
                        </b-button>
                    </b-col>
                </b-row>
            </div> 
            <b-table :items="clientes" :fields="fields"
                responsive 
                borderless
                striped
                medium>
                <template slot="pessoa_id" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.pessoa_id }}</span> <br>
                </template>
                <template slot="nm_pessoa" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_pessoa }}</span> <br>
                    <span style="font-size: smaller;">{{ data.item.cnpj_cpf }}</span>
                </template>
                <template slot="status" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.status }}</span>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="primary" title="Editar Cliente"
                        @click="loadCliente(data.item)" size="sm mr-2">  
                        <i class="fa fa-pencil"></i>
                    </b-button>
                </template>
            </b-table>               
            <b-pagination class="customPagination mt-4" size="md" v-model="page" :total-rows="count" :per-page="limit" />
        </div>
        
        <b-modal ref="modalPesquisa" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Pesquisa Cliente" size="xl">
            <template v-slot:modal-footer="{ pesquisarClientes, limparFiltros }">
                <b-card header="Filtros"> 
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="CNPJ/CPF" label-for="filtro-cnpj_cpf">
                                <b-form-input 
                                    type="text"
                                    id="filtro-cnpj_cpf" 
                                    name="filtro-cnpj_cpf" 
                                    ref="filtro-cnpj_cpf" 
                                    v-model.trim="filtro.cnpj_cpf" 
                                    maxlength="14" 
                                    placeholder="CNPJ/CPF">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="9" sm="12">
                            <b-form-group label="Cliente" label-for="filtro-nome_cliente">
                                <b-form-input 
                                    type="text"
                                    id="filtro-nome_cliente" 
                                    name="filtro-nome_cliente" 
                                    ref="filtro-nome_cliente" 
                                    v-model.trim="filtro.nome_cliente" 
                                    maxlength="100" 
                                    placeholder="Nome Cliente">
                                </b-form-input>
                            </b-form-group>
                        </b-col>                        
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Email" label-for="filtro-email">
                                <b-form-input 
                                    type="text"
                                    id="filtro-email" 
                                    name="filtro-email" 
                                    ref="filtro-email" 
                                    v-model.trim="filtro.email" 
                                    maxlength="50" 
                                    placeholder="E-mail">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>  

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Empresa" label-for="filtro-empSelecionada">
                                <b-form-select 
                                    id="empSelecionada"
                                    name="empSelecionada"
                                    ref="empSelecionada"
                                    v-model.trim="empSelecionada" 
                                    :options="companies"> 
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>  

                </b-card> 

                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="secondary" class="mr-2" style="width: 180px;"
                            @click="pesquisarClientes()"><i class="fa fa-search"></i> Pesquisar 
                        </b-button>
                        <b-button variant="secondary" class="mr-2" style="width: 180px;"
                            @click="limparFiltros()">Limpar Filtros 
                        </b-button>
                    </b-col>
                </b-row>                       
            </template>
        </b-modal>  
       
        <b-modal ref="modalRemove" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Confirmação!">
            <p class="my-4">Deseja realmente excluir esta Cliente manual?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="success" class="mr-2" style="width: 100px;"
                            @click="confirmeRemove()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideRemove()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>          
        
        <div id="pageEdition" v-show="modalActive">
            <b-card :header="tituloModal"> 
                <b-form @submit.prevent="submit">                  
                    <input id="usuario_id" type="hidden" v-model.trim="this.$store.state.user.userid"> 
                    <input id="pessoa-id" type="hidden" v-model.trim="cliente.pessoa_id"> 
              
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Empresa" label-for="cliente-empresa_id">
                                <b-form-select 
                                    id="cliente-empresa_id"
                                    name="cliente-empresa_id"
                                    ref="cliente-empresa_id"
                                    v-focus
                                    :options="companies" v-model.trim="cliente.empresa_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.cliente.empresa_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-cliente">
                        <p>Dados do Cliente</p>
                    </div>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Pessoa" label-for="cliente-fl_pessoa">
                                <b-form-select 
                                    id="cliente-fl_pessoa"
                                    name="cliente-fl_pessoa"
                                    ref="cliente-fl_pessoa"
                                    v-model.trim="cliente.fl_pessoa" :options="optTipoPessoa"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.cliente.fl_pessoa.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="2" sm="12">
                            <b-form-group label="*CNPJ/CPF" label-for="cliente-cpf_cnpj">
                                <b-form-input 
                                    type="text"
                                    id="cliente-cpf_cnpj" 
                                    name="cliente-cpf_cnpj" 
                                    ref="cliente-cpf_cnpj" 
                                    v-model.trim="cliente.cpf_cnpj" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    :class="{ 'form-control is-invalid' : $v.cliente.cpf_cnpj.$error }"

                                    v-mask="cpfCnpjMask()" 

                                    placeholder="Informe Doc"
                                    >
                                </b-form-input>

                            </b-form-group>
                        </b-col>

                        <b-col md="6" sm="12">
                            <b-form-group label="*Nome/Razão" label-for="cliente-nm_pessoa">
                                <b-form-input 
                                    type="text" 
                                    id="cliente-nm_pessoa" 
                                    name="cliente-nm_pessoa"
                                    ref="cliente-nm_pessoa"
                                    v-model.trim="cliente.nm_pessoa" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    :class="{ 'form-control is-invalid' : $v.cliente.nm_pessoa.$error }"
                                    maxlength="100"
                                    placeholder="Informe nome do cliente">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="2" sm="12">
                            <b-form-group label="IM" label-for="cliente-im">
                                <b-form-input 
                                    type="text" 
                                    id="cliente-im" 
                                    name="cliente-im" 
                                    ref="cliente-im" 
                                    v-model.trim="cliente.im" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"                                    
                                    maxlength="15" 
                                    placeholder="Informe IM">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*CEP" label-for="cliente-cep">
                                <b-input-group class="mb-2 custom-input-group">
                                    <b-form-input 
                                        type="text"
                                        id="cliente-cep" 
                                        name="cliente-cep" 
                                        ref="cliente-cep" 
                                        v-model.trim="cliente.cep" 
                                        :class="{ 'form-control is-invalid' : $v.cliente.cep.$error }"
                                        :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                        placeholder="Informe CEP"
                                        maxlength="10">
                                        <!-- v-mask="'##.###-###'" -->
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-button size="sm" text="Button" variant="secondary" class="custom-search-button" 
                                            @click="buscarCep"
                                            :disabled= "((!isInsert) && (!this.$store.state.user.cli_edi))">
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col md="5" sm="12">
                            <b-form-group label="*Endereço" label-for="cliente-endereco">
                                <b-form-input 
                                    type="text"
                                    id="cliente-endereco" 
                                    name="cliente-endereco" 
                                    ref="cliente-endereco" 
                                    v-model.trim="cliente.endereco" 
                                    :class="{ 'form-control is-invalid' : $v.cliente.endereco.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    maxlength="100"                         
                                    placeholder="Informe endereço">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Número" label-for="cliente-numero">
                                <b-form-input 
                                    type="text"
                                    id="cliente-numero" 
                                    name="cliente-numero" 
                                    ref="cliente-numero" 
                                    v-model.trim="cliente.numero" 
                                    :class="{ 'form-control is-invalid' : $v.cliente.numero.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    maxlength="10"                         
                                    placeholder="Informe número">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Bairro" label-for="cliente-bairro">
                                <b-form-input 
                                    type="text"
                                    id="cliente-bairro" 
                                    name="cliente-bairro" 
                                    ref="cliente-bairro" 
                                    v-model.trim="cliente.bairro" 
                                    :class="{ 'form-control is-invalid' : $v.cliente.bairro.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    maxlength="30" 
                                    placeholder="Informe bairro">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group label="Complemento" label-for="cliente-complemento">
                                <b-form-input 
                                    type="text"
                                    id="cliente-complemento" 
                                    name="cliente-complemento" 
                                    ref="cliente-complemento" 
                                    v-model.trim="cliente.complemento" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    maxlength="70"                      
                                    placeholder="Informe complemento">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="8" sm="12">
                            <b-form-group label="Município/UF" label-for="cliente-municipio_id">
                                <b-form-select 
                                    id="cliente-municipio_id"
                                    name="cliente-municipio_id"
                                    ref="cliente-municipio_id"
                                    :options="citiesCache" v-model.trim="cliente.municipio_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    :class="{ 'form-control is-invalid' : $v.cliente.municipio_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Telefone" label-for="cliente-telefone">
                                <b-form-input 
                                    type="text"
                                    id="cliente-telefone" 
                                    name="cliente-telefone" 
                                    ref="cliente-telefone" 
                                    v-model.trim="cliente.telefone" 
                                    v-mask="'(##) #########'"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    placeholder="Informe telefone">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="5" sm="12">
                            <b-form-group label="E-mail" label-for="cliente-email">
                                <b-form-input 
                                    type="text"
                                    id="cliente-email" 
                                    name="cliente-email" 
                                    ref="cliente-email" 
                                    v-model.trim="cliente.email" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"
                                    maxlength="50" 
                                    placeholder="Informe e-mail">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="2" sm="12">
                            <b-form-group label="*Enviar no E-mail?" label-for="cliente-fl_envia_email">
                                <b-form-select 
                                    id="cliente-fl_envia_email"
                                    name="cliente-fl_envia_email"
                                    ref="cliente-fl_envia_email"
                                    v-model.trim="cliente.fl_envia_email" :options="optSimNao"
                                    :class="{ 'form-control is-invalid' : $v.cliente.fl_envia_email.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="2" sm="12">
                            <b-form-group label="*Status" label-for="cliente-fl_status">
                                <b-form-select 
                                    id="cliente-fl_status"
                                    name="cliente-fl_status"
                                    ref="cliente-fl_status"
                                    v-model.trim="cliente.fl_status" :options="optStatus"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"       
                                    :class="{ 'form-control is-invalid' : $v.cliente.fl_status.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-cliente">
                        <p>Produto/Serviço Padrão</p>
                    </div>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Obrigatório somente se utilizar módulo de faturamento pela plataforma" label-for="cliente-produto_id_def">
                                <b-form-select 
                                    id="cliente-produto_id_def"
                                    name="cliente-produto_id_def"
                                    ref="cliente-produto_id_def"
                                    v-model.trim="cliente.produto_id_def" 
                                    :options="services"
                                    value-field="item"
                                    text-field="name"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Complemento da Nota" label-for="cliente-complemento_produto">
                                <b-form-textarea
                                    type="text"
                                    id="cliente-complemento_produto" 
                                    name="cliente-complemento_produto" 
                                    ref="cliente-complemento_produto" 
                                    v-model.trim="cliente.complemento_produto" 
                                    rows="3"
                                    max-rows="3"
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="Vlr. Fatura" label-for="cliente-vlr_produto">
                                <input 
                                    type="text" 
                                    id="cliente-vlr_produto" 
                                    name="cliente-vlr_produto" 
                                    ref="cliente-vlr_produto" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-model.trim="cliente.vlr_produto" 
                                    v-money="money" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.cli_edi))"/> 
                            </b-form-group>
                        </b-col>  
                    </b-row>

                    <hr>
                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModal">Cancelar
                        </b-button>  
                        <b-button variant="success" id="btn-principal" class="mr-2" style="width: 150px;"    
                            v-if="((((isInsert) || (this.$store.state.user.cli_edi))) || ((isInsert) && (typeof(cliente.fl_status === 'undefined'))))" 
                            @click="saveCliente">Salvar 
                        </b-button>
                    </div>
                </b-form>        
            </b-card>
        </div>

    </div>  
</template>

<script>
import { baseApiUrl, showError } from '@/global'

import { mapState } from 'vuex'

import axios from 'axios'

import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'
import citiesJson from '../../cache-data/municipios.json'

import { required, minLength } from "vuelidate/lib/validators";
import formMixin from '../../config/mixinform';

import {VMoney} from 'v-money'

export default {
    name: 'Clientes',
    
    computed: mapState(['user']),

    components: { PageTitle, Modal },

    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            tituloModal: null,
            isInsert: false,

            filtro: {},
            cliente: {},
            clientes: [],
            companies: [],

            fields: [
                { key: 'pessoa_id', label: 'ID' },
                { key: 'nm_pessoa', label: 'Cliente' },
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Ações' }
            ],
            page: 1,
            paginar: '10',
            count: 0,
            limit: 0,
            
            optSimNao: [
                { value: "S", text: 'Sim' },
                { value: "N", text: 'Não' }
            ],

            optTipoPessoa: [
                { value: "F", text: 'Física' },
                { value: "J", text: 'Juridica' },
                { value: "E", text: 'Estrangeira' }
            ],

            situacaoSelecionada: 'T',            

            optStatus: [
                { value: "A", text: 'Ativo' },
                { value: "I", text: 'Inativo' }
            ],
            
            empSelecionada: null,            
            citiesCache: [],
            services: [],

            money: {
                decimal: ',',
                thousands: '.',	
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false 
            }

        }
    },

    validations: {
        cliente: {
            empresa_id: { required },
            fl_pessoa: { required },
            nm_pessoa: { required },
            cpf_cnpj: { required },
            cep: { required, minLength: minLength(8) },
            endereco: { required },
            numero: { required },
            bairro: { required },
            municipio_id: { required },
            fl_envia_email: { required },
            fl_status: { required }
        }
        //telefone: { required, minLength: minLength(13) }, 
        //email: { required, email },
    },

    directives: {money: VMoney},    

    methods: {
        loadClientes() {
            var pcnpj_cpf     = document.getElementById('filtro-cnpj_cpf').value;
            var pnome_cliente = document.getElementById('filtro-nome_cliente').value;
            var pemail        = document.getElementById('filtro-email').value;
            var pid_emp = this.empSelecionada;
            const pid_emps = pid_emp !== null ? pid_emp : this.$store.state.user.empsuser;

            // Parametros para filtros aplicados pelo usuario
            const config = {
                headers: {
                    cnpj_cpf: pcnpj_cpf,
                    nome_cliente: pnome_cliente,
                    email: pemail
                }
            };           

            const url = `${baseApiUrl}/cliente/empsusuario/${pid_emps}/pagina/${this.page}/paginar/${this.paginar}`
            axios.get(url, config)
                  .then(resp => {
                     this.clientes = resp.data.data
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)
            })
        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresas/` + this.$store.state.user.userid)  
                 .then(resp => {
                     this.companies = resp.data.data.map(campany => {
                         return { value: campany.empresa_id, text: campany.nm_empresa }
                     })
            })
        },

        loadProducties() {
            axios.get(`${baseApiUrl}/empresa/produtos/empsusuario/${this.$store.state.user.empsuser}`)  
                 .then(resp => {
                     this.services = resp.data.data.map(service => {
                         return { item: service.item, name: service.name }
                     })
            })
        },

        // Cache local
        loadCitiesCache() {
            let cities = citiesJson.map(city => {
                return { value: city.municipio_id, text: city.nm_municipio }
            })
            this.citiesCache = cities
        },

        cpfCnpjMask() {
            if (this.cliente.fl_pessoa === 'F') {
                return '###.###.###-##'; // Máscara de CPF
            } else if (this.cliente.fl_pessoa === 'J') {
                return '##.###.###/####-##'; // Máscara de CNPJ
            } else if (this.cliente.fl_pessoa === 'E') {
                return ''; // Máscara para Estrangeiro
            }
        },

        formatacpfCnpj() {
            const inputValue = this.cliente.cpf_cnpj.replace(/\D/g, ''); // Remover não dígitos
            
            if (this.cliente.fl_pessoa === 'F') {
                const formattedValue = inputValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'); // Aplicar máscara para CPF
                this.cliente.cpf_cnpj = formattedValue;
            } else if (this.cliente.fl_pessoa === 'J') {
                const formattedValue = inputValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'); // Aplicar máscara para CNPJ
                this.cliente.cpf_cnpj = formattedValue;
            } else if (this.cliente.fl_pessoa === 'E') {
                this.cliente.cpf_cnpj = inputValue;
            }
        },

        loadCliente(cliente, mode = 'save') {
            this.mode = mode
            this.cliente = { ...cliente } 

            axios.get(`${baseApiUrl}/cliente/cliente/${cliente.pessoa_id}`)
                 .then(resp => {
                     this.cliente = resp.data.data
            })
            this.tituloModal = 'Editar Cliente'
            this.toggleModal()

            this.formatacpfCnpj();
        },

        addCliente() {
            this.company = {}

            this.tituloModal = 'Adicionar Cliente'
            this.toggleModal()

            this.isInsert = true;
        },

        toggleModal() {
            this.modalActive = !this.modalActive;

            if (this.modalActive === false) {
                this.reset()
            }

            this.$v.$reset();                    
		},

        togglePesquisa() {
            this.$refs.modalPesquisa.show();
		},

        limparFiltros() {
            this.situacaoSelecionada = 'T';
            document.getElementById('filtro-cnpj_cpf').value = "";
            document.getElementById('filtro-nome_cliente').value = "";
            document.getElementById('filtro-email').value = "";
            this.empSelecionada = null;

            this.$refs.modalPesquisa.hide();
           
            this.page = 1;
            this.reset();
        },

        pesquisarClientes() { 
            this.page = 1;
            this.loadClientes()
            this.$refs.modalPesquisa.hide();
        },

        reset() {
            this.mode = 'save'
            this.isInsert = false;
            this.cliente = {}
            this.loadClientes()
        },

        saveCliente() {
            if (this.validate()) {
                const method = this.cliente.pessoa_id ? 'put' : 'post'
                const cliente = this.cliente.pessoa_id ? `/cliente/${this.cliente.pessoa_id}` : ''
                const usuario = `/usuario/${this.$store.state.user.userid}`
                const url = `${baseApiUrl}/cliente/empresa${cliente}${usuario}`      

                axios[method](url, this.cliente)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)                

                this.toggleModal() 
            }
        },

        removeCliente(nfse) {
            this.cliente = { ...nfse } 
            this.$refs.modalRemove.show(nfse);
        },

        hideRemove() { 
            this.$refs.modalRemove.hide();
        },

        confirmeRemove() { 
            this.hideRemove();
            const id = this.cliente.nfse_id
            axios.delete(`${baseApiUrl}/cliente/${id}`)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()
                     this.reset()
                 })
                 .catch(showError)
        },

        buscarCep() {
            if (this.cliente.cep) {
                document.getElementById('cliente-endereco').value = ''
                document.getElementById('cliente-numero').value = ''
                document.getElementById('cliente-bairro').value = ''
                document.getElementById('cliente-complemento').value = ''
                document.getElementById('cliente-municipio_id').value = ''

                axios.get(`${baseApiUrl}/endereco/cep/${this.cliente.cep}`)
                    .then(resp => {
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                            if (resp.data.logradouro !== '') {
                                document.getElementById('cliente-endereco').value = resp.data.logradouro
                            }
                            if (resp.data.bairro !== '') {
                                document.getElementById('cliente-bairro').value = resp.data.bairro
                            }
                            if (resp.data.complemento !== '') {
                                document.getElementById('cliente-complemento').value = resp.data.complemento
                            }
                            if (resp.data.ibge !== '') {
                                document.getElementById('cliente-municipio_id').value = resp.data.ibge
                            }
                        } else 
                        {
                            this.$toasted.global.defaultWarning({ msg: resp.data.mensagem })
                        }
                    })
                    .catch(showError) 
            }
        }        

    },

    watch: {
        page() {
            this.loadClientes()
        }
    },

    mounted() {
        this.loadClientes() 
        this.loadCompanies()
        this.loadProducties()
        // Cache
        this.loadCitiesCache()
    }    
}

</script>

<style scoped>
    .title-cliente {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
   
</style>